var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.3545 20.2539H8.05859C5.84945 20.2539 4.05859 22.0448 4.05859 24.2539V38.0332C4.05859 40.2423 5.84945 42.0332 8.05859 42.0332H36.3545C38.5636 42.0332 40.3545 40.2423 40.3545 38.0332V24.2539C40.3545 22.0448 38.5636 20.2539 36.3545 20.2539Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.0957 22.0703H11.3174C11.3172 23.5141 10.7435 24.8987 9.7225 25.9195C8.7015 26.9403 7.31682 27.5137 5.87305 27.5137V34.7735C6.58808 34.7735 7.29611 34.9143 7.9567 35.188C8.61729 35.4617 9.2175 35.8628 9.72306 36.3685C10.2286 36.8741 10.6296 37.4744 10.9032 38.135C11.1767 38.7957 11.3175 39.5037 11.3174 40.2188H33.0957C33.0956 39.5037 33.2363 38.7957 33.5099 38.135C33.7835 37.4744 34.1845 36.8741 34.69 36.3685C35.1956 35.8628 35.7958 35.4617 36.4564 35.188C37.117 34.9143 37.825 34.7735 38.54 34.7735V27.5137C37.0963 27.5137 35.7116 26.9403 34.6906 25.9195C33.6696 24.8987 33.0959 23.5141 33.0957 22.0703Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.835 31.1445C25.8347 31.8623 25.6216 32.5638 25.2226 33.1605C24.8237 33.7571 24.2568 34.2221 23.5936 34.4966C22.9304 34.7711 22.2007 34.8428 21.4968 34.7026C20.7929 34.5624 20.1463 34.2167 19.6389 33.7091C19.1314 33.2015 18.7858 32.5549 18.6459 31.8509C18.5059 31.1469 18.5778 30.4173 18.8524 29.7542C19.1271 29.091 19.5922 28.5243 20.189 28.1255C20.7857 27.7267 21.4873 27.5138 22.2051 27.5137C22.6819 27.5136 23.154 27.6075 23.5945 27.79C24.035 27.9724 24.4352 28.2399 24.7723 28.5771C25.1094 28.9142 25.3767 29.3145 25.5591 29.7551C25.7414 30.1956 25.8352 30.6678 25.835 31.1445Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.8457 36.5879H13.2832V38.4024H19.8457V36.5879Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M40.0283 5.97656H11.9902C9.7811 5.97656 7.99023 7.76742 7.99023 9.97656V27.7168C7.99023 29.9259 9.7811 31.7168 11.9902 31.7168H40.0283C42.2375 31.7168 44.0283 29.9259 44.0283 27.7168V9.97656C44.0283 7.76742 42.2375 5.97656 40.0283 5.97656Z",
    fill: "#9B62FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M44.0283 9.85938H7.99023V15.8594H44.0283V9.85938Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M37.96 18.832H35.6289C34.5243 18.832 33.6289 19.7275 33.6289 20.832V23.1641C33.6289 24.2686 34.5243 25.1641 35.6289 25.1641H37.96C39.0645 25.1641 39.96 24.2686 39.96 23.1641V20.832C39.96 19.7275 39.0645 18.832 37.96 18.832Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.8496 25.2383H14.1348C13.8695 25.2383 13.6152 25.1329 13.4277 24.9454C13.2401 24.7579 13.1348 24.5035 13.1348 24.2383C13.1348 23.9731 13.2401 23.7187 13.4277 23.5312C13.6152 23.3436 13.8695 23.2383 14.1348 23.2383H20.8496C21.1148 23.2383 21.3692 23.3436 21.5567 23.5312C21.7442 23.7187 21.8496 23.9731 21.8496 24.2383C21.8496 24.5035 21.7442 24.7579 21.5567 24.9454C21.3692 25.1329 21.1148 25.2383 20.8496 25.2383Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.7725 21.5742H14.1348C13.8695 21.5742 13.6152 21.4689 13.4277 21.2813C13.2401 21.0938 13.1348 20.8394 13.1348 20.5742C13.1348 20.309 13.2401 20.0546 13.4277 19.8671C13.6152 19.6796 13.8695 19.5742 14.1348 19.5742H15.7725C16.0377 19.5742 16.292 19.6796 16.4796 19.8671C16.6671 20.0546 16.7725 20.309 16.7725 20.5742C16.7725 20.8394 16.6671 21.0938 16.4796 21.2813C16.292 21.4689 16.0377 21.5742 15.7725 21.5742Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25.7714 25.2383H24.4492C24.184 25.2383 23.9296 25.1329 23.7421 24.9454C23.5546 24.7579 23.4492 24.5035 23.4492 24.2383C23.4492 23.9731 23.5546 23.7187 23.7421 23.5312C23.9296 23.3436 24.184 23.2383 24.4492 23.2383H25.7715C26.0367 23.2383 26.291 23.3436 26.4786 23.5312C26.6661 23.7187 26.7715 23.9731 26.7715 24.2383C26.7715 24.5035 26.6661 24.7579 26.4786 24.9454C26.291 25.1329 26.0367 25.2383 25.7715 25.2383H25.7714Z",
    fill: "#DBC6FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.e4d4c96f759b6f119bec786047a30a75.svg";
export { ForwardRef as ReactComponent };